/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountQuoteRequest as ModelsV3LoanManagementAccountQuoteRequest } from '../../models/Models/v3/LoanManagement/account-quote-request';
import { AccountQuoteResponse as ModelsV3LoanManagementAccountQuoteResponse } from '../../models/Models/v3/LoanManagement/account-quote-response';

export interface V3LoanManagementQuotesPost$Json$Plain$Params {
      body?: ModelsV3LoanManagementAccountQuoteRequest
}

export function v3LoanManagementQuotesPost$Json$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementQuotesPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementQuotesPost$Json$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAccountQuoteResponse>;
    })
  );
}

v3LoanManagementQuotesPost$Json$Plain.PATH = '/v3/loan-management/quotes';
